export const NM_DASHBOARD_PHRASES = {
    WELCOME_TITLE: 12336,
    WELCOME_TEXT: 12337,
    LENGTH: 12321,
    YOU_CAN_EARN: 12320,
    NOTE_INFO: 12425,
    JOIN_TEXT: 12367,
    CREATE_ACCOUNT_BUTTON: 12368,
    STUDY_NUMBER: 967,
    SURVEY_LENGTH: 12321,
    DEADLINE: 3362,
    MIN: 1496,
    UP_TO: 3664,
} as const;
